<template>
	<span>
		货币类型：
		<el-select v-model="value" placeholder="请选择" @change="selectType" size="mini">
		    <el-option
			 v-for="item in moneyList"
			 :key="item.value"
			 :label="item.name"
			 :value="item.label">
		    </el-option>
		  </el-select>		
	</span>

</template>

<script>
export default{
	data(){
		return{
			value:'',
		   moneyList: [{
				name: '人民币',
				nameEn: 'Ren Min Bi',
				label: 'RMB'
			},
			{
				name: '美元',
				nameEn: 'U.S. Dollar',
				label: 'USD'
			},
			{
				name: '欧元',
				nameEn: 'Euro',
				label: 'EUR'
			},
			{
				name: '日元',
				nameEn: 'Japanese Yen',
				label: 'JPY'
			},
			{
				name: '新台币',
				nameEn: 'New Taiwan Currency',
				label: 'TWD'
			}
		   ],
		}
	},
	methods:{
		selectType(){
			this.$emit('rmbType',this.value)
		}
	}
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/common/rmb/index.vue